import { Button, Box, Typography, Container } from "@mui/material";
import { theme } from "../styles/theme";
import * as styles from "../styles/WelcomeScreen.module.scss";

const WelcomeScreen: React.FC<{
  title: string;
  text: string;
  handleNextStep: () => void;
  buttonText: string;
}> = ({ title, text, handleNextStep, buttonText }) => {
  return (
    <Container
      sx={{ backgroundColor: "inherit" }}
      className={styles.WelcomeScreen}
    >
      <Box className={styles.welcomeContentContainer}>
        <Box
          className={styles.welcomeContent}
          color={theme.palette.common.white}
        >
          <Typography variant="h3">{title}</Typography>
          <Typography variant="h5">{text}</Typography>
        </Box>
        <Button
          color="primary"
          variant="contained"
          disableElevation
          fullWidth
          onClick={handleNextStep}
        >
          {buttonText}
        </Button>
      </Box>
    </Container>
  );
};

export default WelcomeScreen;
